/* istanbul ignore file */
import moment from 'moment';
import {
  OPPORTUNITY_STAGES_ALLOWED_TRANSITIONS,
  isCurrentOpportunityStage,
  isCompletedOpportunityStage,
} from 'domain/sales/opportunity/opportunityService';
import { DateField, TextField } from 'framework/ui/field';
import { UiThemeOverrider } from 'framework/uiTheme';
import GuidanceForSuccessField from 'domain/sales/opportunity/shared/OpportunityPipeline/GuidanceForSuccessField';
import MarkStateAsCompletedButton from 'domain/sales/opportunity/shared/OpportunityPipeline/button/MarkStateAsCompletedButton';
import MarkAsCurrentStateButton from 'domain/sales/opportunity/shared/OpportunityPipeline/button/MarkAsCurrentStateButton';
import OpportunityPipelineFieldLayout from 'domain/sales/opportunity/shared/OpportunityPipeline/OpportunityPipelineFieldLayout';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import { Stack } from '@mui/material';
import { CountDownTimer } from 'framework/ui/ui-builder';

const OpportunityPipelineDescription = ({
  currentStep,
  activeStepData,
  handleStep,
  isPipelineFailed,
  isPostponed,
}: {
  currentStep: string;
  activeStepData: Dictionary<any>;
  handleStep: (step: string) => void;
  isPipelineFailed: boolean;
  isPostponed: boolean;
}) => {
  const { stepName: activeStep, startedAt, plannedFinishedAt, actualFinishedAt, stateStatus } = activeStepData;
  const currentStepAllowedTransitions = OPPORTUNITY_STAGES_ALLOWED_TRANSITIONS[currentStep] || [];
  const getInProgressValue = () => {
    if (isPostponed && currentStep === activeStep) {
      return <PauseCircleOutlineIcon color="warning" />;
    }
    return startedAt ? (
      <CountDownTimer
        targetDate={startedAt}
        shouldCountFromTargetDate
        isExpired={!moment(plannedFinishedAt).isAfter(moment())}
        showMonths={false}
        stopDatetime={actualFinishedAt}
      />
    ) : null;
  };

  return (
    <UiThemeOverrider
      overriddenLayouts={{
        BaseFieldLayout: OpportunityPipelineFieldLayout,
      }}
    >
      <div className="step-description__wrapper">
        <GuidanceForSuccessField activeStep={activeStep} />
        <Stack className="step-description__attributes">
          <Stack
            className="step-description__item"
            direction="row"
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <DateField source="startedAt" value={startedAt} label="Start date" />
          </Stack>
          <Stack
            className="step-description__item"
            direction="row"
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <DateField
              source="plannedFinishedAt"
              value={plannedFinishedAt}
              label="Planned date of transition to the next stage"
            />
          </Stack>
          <Stack
            className="step-description__item"
            direction="row"
            justifyContent="space-between"
            alignItems="flex-end"
          >
            <TextField label="In progress" source="startedAt" value={getInProgressValue()} />
          </Stack>
          {isCurrentOpportunityStage(stateStatus) && !isPostponed ? (
            <MarkStateAsCompletedButton activeStep={activeStep} handleStep={handleStep} />
          ) : null}
          {!isCompletedOpportunityStage(stateStatus) &&
          !isPostponed &&
          !isPipelineFailed &&
          currentStepAllowedTransitions.includes(activeStep) ? (
            <MarkAsCurrentStateButton activeStep={activeStep} />
          ) : null}
        </Stack>
      </div>
    </UiThemeOverrider>
  );
};

export default OpportunityPipelineDescription;
